import React from 'react'
import { Checkbox, FormControlLabel, TextField } from '@mui/material'
import { useFormikContext } from 'formik'
import Autocomplete from '@mui/material/Autocomplete'
import _ from 'lodash'
import { TooltipIconWrapper } from '../MatxTooltip/MatxTooltip'


const VisualTagsField = ({
  name: key,
  label,
  options,
  autoCompleteProps,
  disabled,
  placeholder,
  controlType,
  inputType
}) => {
  const {
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    values,
    touched,
    errors,
  } = useFormikContext()

  const name = `visualTags.${key}`
  const helperText = _.get(touched, name) && _.get(errors, name)
  const _handleChange= (e) => {
    handleChange(e)
    setFieldTouched(name)
  }

  // If options are provided, use them to render a autocomplete
  if (Array.isArray(options)) {
    return (
      <Autocomplete
        disabled={disabled}
        key={name}
        options={options}
        value={_.get(values, name)}
        onInputChange={() => setFieldTouched(name)}
        onChange={(_, value) => {
          setFieldValue(name, value)
          setFieldTouched(name)
        }}
        getOptionLabel={(option) => `${option}`}
        {...autoCompleteProps}
        renderInput={(params) => (
          <TextField
            {...params}
            className="mb-4"
            name={name}
            label={label}
            placeholder={placeholder}
            variant="outlined"
            size="small"
            fullWidth
            error={!!helperText}
            helperText={helperText}
          />
        )}
      />
    )
  }
  
  if(controlType === 'checkbox') {
    return (
      <FormControlLabel
        key={name}
        name={name}
        className='mb-4'
        control={
          <Checkbox
            disabled={disabled}
            onChange={(_, value) => setFieldValue(name, value)}
            checked={!!_.get(values, name)}
          />
        }
        label={label}
      />
    )
  }

  return (
    <TextField
      disabled={disabled}
      key={name}
      name={name}
      className="mb-4"
      label={label}
      placeholder={placeholder}
      variant="outlined"
      size="small"
      fullWidth
      type={inputType}
      onBlur={handleBlur}
      onChange={_handleChange}
      value={_.get(values, name) || ''}
      error={!!helperText}
      helperText={helperText}
    />
  )
}

const withTooltip = (Component) => (props) => {
  const { tooltip, ...rest } = props
  if (!tooltip) return <Component {...rest} />

  return (
    <TooltipIconWrapper title={tooltip}>
      <Component {...rest} />
    </TooltipIconWrapper>
  )
}

export default withTooltip(VisualTagsField)
